import {
  Box,
  Divider,
  Text,
  VStack,
  Image,
  useBreakpointValue,
  Input,
  Button,
} from "@chakra-ui/react";
import { useState } from "react";
import HookForm from "./form";

function Grievance() {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const isDesktop = useBreakpointValue({ base: false, md: true });

  const [password, setPassword] = useState("");
  const [authenticated, setAuthenticated] = useState(false);
  const [showFormPage, setShowFormPage] = useState(false);
  const [formStatus, setFormStatus] = useState("idle"); // 'idle' | 'sent'

  const correctPassword = process.env.REACT_APP_PASSWORD;

  const handlePasswordSubmit = () => {
    if (password === correctPassword) {
      setAuthenticated(true);
    } else {
      alert("Incorrect password!");
    }
  };

  // Password screen
  if (!authenticated) {
    return (
      <Box
        maxW="100%"
        overflow="hidden"
        minH="100vh"
        bgColor="#ffe6f0"
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
      >
        <Text fontSize="lg" textAlign="center" mb="4">
          Kaaju's Grievances Portal. Please enter the password!
        </Text>
        <Input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter password"
          width="300px"
          mb="4"
        />
        <Button onClick={handlePasswordSubmit}>Submit</Button>
      </Box>
    );
  }

  // Welcome screen
  if (authenticated && !showFormPage) {
    return (
      <Box
        maxW="100%"
        overflow="hidden"
        minH="100vh"
        bgColor="#e6d7ff"
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        p="6"
      >
        <Image src="Images/shiba.gif" alt="shiba dancing" w="20%" mb="4" />
        <Text fontSize="xl" textAlign="center" mb="4" w="50%">
          Welcome to the grievance page! Please submit any and all complaints
          against le boyfriend here, and you will receive a prompt response.
        </Text>
        <Button onClick={() => setShowFormPage(true)}>Next</Button>
      </Box>
    );
  }

  // Desktop view - form or success screen
  if (isDesktop) {
    return (
      <Box maxW="100%" overflow="hidden" minH="100vh" bgColor="#e6d7ff">
        {formStatus === "sent" ? (
          <VStack w="100%" justify="center" p="5">
            <Image
              objectFit="cover"
              src="Images/cat.gif"
              alt="shiba dancing"
              w="15%"
              mb="4"
            />
            <Text fontSize="xl" fontWeight="bold" w="50%" textAlign="center">
              Thank you! Your grievance has been sent. Divij shall respond to
              this as soon as he can!
            </Text>
            <Button onClick={() => setFormStatus("idle")}>
              Submit Another
            </Button>

            <Text fontSize="md" textAlign="center" w="50%">
              Divij's memory of the day: When I saw you that night for the CSO concert. I couldn't believe how gorgeous you looked.
            </Text>
            <Divider borderColor="black" borderWidth="2px" mt="10%" w="60%" />
            <Text w="100%" textAlign="center" p="1%">
              Designed by your divij.
            </Text>
          </VStack>
        ) : (
          <VStack w="100%" justify="center" p="5">
            <Image
              objectFit="cover"
              src="Images/shiba2.gif"
              alt="shiba dancing"
              w="15%"
              mb="4"
            />
            <Text fontSize="lg" textAlign="center" w="50%">
              Submit your complaints here!
            </Text>
            <HookForm onSuccess={() => setFormStatus("sent")} />
          </VStack>
        )}
      </Box>
    );
  }

  if (isMobile) {
    return (
      <Box maxW="100%" overflow="hidden" minH="100vh" bgColor="#e6d7ff" p="4">
        {formStatus === "sent" ? (
          <VStack w="100%" justify="center" spacing="6">
            <Image
              objectFit="cover"
              src="Images/agag.gif"
              alt="shiba dancing"
              w="50%"
              mb="2"
            />
            <Text fontSize="md" fontWeight="bold" textAlign="center">
              Thank you! Your grievance has been sent. Divij shall respond to
              this as soon as he can!
            </Text>
            <Button onClick={() => setFormStatus("idle")}>
              Submit Another
            </Button>
             <Text fontSize="md" textAlign="center" w="50%">
              Divij's memory of the day: When I saw you that night for the CSO concert. I couldn't believe how gorgeous you looked.            </Text>
            <Divider borderColor="black" borderWidth="1px" w="80%" />
            <Text textAlign="center" fontSize="sm">
              Designed by your divij.
            </Text>
          </VStack>
        ) : (
          <VStack w="100%" justify="center" spacing="6">
            <Image
              objectFit="cover"
              src="Images/shiba2.gif"
              alt="shiba dancing"
              w="50%"
              mb="2"
            />
            <Text fontSize="md" textAlign="center">
              Submit your complaints here!
            </Text>
            <HookForm onSuccess={() => setFormStatus("sent")} />
          </VStack>
        )}
      </Box>
    );
  }

  return null;
}

export default Grievance;
